/* eslint-disable jsx-a11y/heading-has-content */
import styles from "../SalesEndOfDay.module.scss";
import primaryComponents from "../../../primaryComponents";
import secondaryComponents from "../..";
import useEndOfDayDetails from "./useEndOfDayDetails";
import { motion } from "framer-motion";
import { formatCurrency, setToDateMonthYearInWords } from "../../../../helpers";
import { useSelector } from "react-redux";
import Spinner from "../../../../assets/svgIcons/Spinner";
import Completed from "../../../../assets/svgIcons/Completed";
import Modal from "../../Modal/Modal";
import DownloadModal from "./DownloadModal";
import PrintIcon from "../../../../assets/svgIcons/PrintIcon";
import EndOdDayMetabase from "./EndOfDayMetabase";
import { useEffect } from "react";
import globalStyles from "../../../../assets/styles/base/globalPage.module.scss";

const EndOfDayDetails = ({
  endOfDayDetails,
  setEndOfDayDetails,
  endOfDayFormDetails,
  props,
  getFormatedEndOfDay = () => {},
  setProps = () => {},
}) => {
  const {
    downloadUrl,
    loadingPercent,
    isDownloadReport,
    sucessEndOfDay,
    downloadModal,
    productSummaryLoadingRef,
    salesSummaryLoadingRef,
    isCreatingUrl,
    advancedEndOfDay,
    setAdvancedEndOfDay,
    createEndOfDayDetailsUrl,
    setIsDownloadReport,
    downloadEndOfDay,
    setDownloadModal,
  } = useEndOfDayDetails({
    endOfDayFormDetails,
    getFormatedEndOfDay,
  });
  const { currency_code } = useSelector(
    (state) => state.profileDetailsReducer.businessDetails,
  );

  useEffect(() => {
    if (!advancedEndOfDay)
      setProps({
        ...props,
        headerTitle: "End of Day",
        hasPrevNavigation: true,
        routeToPrev: () => setEndOfDayDetails(null),
      });
  }, [advancedEndOfDay, endOfDayDetails]);

  return (
    <>
      {isDownloadReport ? (
        <div className={styles.processingContainer}>
          {sucessEndOfDay ? (
            <div className="d-flex align-items-center">
              <h4 className="mr-2">Your Report is Ready</h4>
              <Completed />
            </div>
          ) : (
            <h4>We Are Processing Your Report</h4>
          )}
          {!sucessEndOfDay && <p>This usually take 2 to 3 mins</p>}
          <div className="d-flex align-items-center mt-4 mb-2">
            {!sucessEndOfDay && <Spinner />}
            <span className="ml-2">
              <b>{loadingPercent}</b>{" "}
              {sucessEndOfDay ? (
                <span style={{ color: "#19AE57" }}>processing</span>
              ) : (
                <span>processing</span>
              )}
            </span>
          </div>
          <div className={styles.progressContainer}>
            <div
              style={{
                width: loadingPercent,
                background: sucessEndOfDay ? "#19AE57" : "#7647ee",
              }}
              className={styles.progress}
            />
          </div>
          {sucessEndOfDay && downloadUrl && (
            <primaryComponents.Button
              onClick={() => window.open(downloadUrl, "_blank")}
              classNames="btn btn--primary cover"
              style={{ marginTop: 40 }}
            >
              View Report
            </primaryComponents.Button>
          )}
        </div>
      ) : (
        <>
          {advancedEndOfDay ? (
            <EndOdDayMetabase
              advancedEndOfDay={advancedEndOfDay}
              setAdvancedEndOfDay={setAdvancedEndOfDay}
              setProps={setProps}
            />
          ) : (
            <>
              <primaryComponents.Button
                className="btn btn--orange ml-auto mb-2"
                isLoading={isCreatingUrl}
                isDisabled={isCreatingUrl}
                loadingText="Processing..."
                onClick={() => createEndOfDayDetailsUrl()}
                style={{ position: "sticky", top: "70px", zIndex: 1 }}
              >
                Advanced End of Day
              </primaryComponents.Button>

              <motion.div className={styles.endOfDayDetails}>
                <div>
                  <h4>End Of Day Details</h4>

                  <div className={`${styles.rowCover} mb-4`}>
                    <div className={styles.rowItem}>
                      <p>Report Date:</p>
                      <p className="dark--text">
                        {endOfDayDetails?.report_start_date
                          ? `${setToDateMonthYearInWords(
                              endOfDayDetails?.report_start_date,
                            )} - ${setToDateMonthYearInWords(
                              endOfDayDetails?.report_end_date,
                            )}`
                          : "N/A"}
                      </p>
                    </div>
                    <div className={styles.rowItem}>
                      <p>Time:</p>
                      <p className="dark--text">
                        {endOfDayDetails?.report_start_time
                          ? `${endOfDayDetails?.report_start_time} - ${endOfDayDetails?.report_end_time}`
                          : "N/A"}
                      </p>
                    </div>
                    <div className={styles.rowItem}>
                      <p>Store(s):</p>
                      <p className="dark--text">
                        {endOfDayDetails?.store_names || "N/A"}
                      </p>
                    </div>
                    <div className={styles.rowItem}>
                      <p>Business:</p>
                      <p className="dark--text">
                        {endOfDayDetails?.business_name || "N/A"}
                      </p>
                    </div>
                    {endOfDayFormDetails?.initiators?.length > 0 ? (
                      <div className={styles.rowItem}>
                        <p>Initiators:</p>
                        <p className="dark--text">
                          {endOfDayFormDetails?.initiators?.map(
                            (initiator, index) =>
                              `${initiator?.label}${
                                endOfDayFormDetails?.initiators?.length !==
                                index + 1
                                  ? ", "
                                  : ""
                              }`,
                          ) || "N/A"}
                        </p>
                      </div>
                    ) : null}
                  </div>

                  {/* summary section  */}
                  <div className={styles.orderBody}>
                    {/* succesful */}
                    <div className={styles.orderBody__table}>
                      <div className={styles.orderBody__table__header}>
                        <h5>
                          Order Status{" "}
                          <span className="ml-3 success--squared small-text-size">
                            Successful
                          </span>
                        </h5>
                      </div>
                      <div className={styles.rowCover}>
                        {endOfDayDetails?.completed_order_data?.length > 0 ? (
                          <>
                            <div className={styles.rowItem}>
                              <p className={styles.item}>SALES</p>
                              <p className={styles.item}>COUNT</p>
                              <p className={styles.item}>AMOUNT</p>
                            </div>
                            {endOfDayDetails?.completed_order_data?.map(
                              (item, index) => (
                                <div className={styles.rowItem} key={index}>
                                  <p className={styles.item}>
                                    {item?.sales === "warehouse_checkout"
                                      ? "Warehouse"
                                      : item?.sales}
                                  </p>
                                  <p className={styles.item}>{item?.counts}</p>
                                  <p className={styles.item}>
                                    {formatCurrency({
                                      value: `${item?.amount}`?.replace(
                                        /[^\d.-]/g,
                                        "",
                                      ),
                                      currencyCode: currency_code,
                                    })}
                                  </p>
                                </div>
                              ),
                            )}
                            <hr />
                            <div className={styles.rowItem}>
                              <h6 className={styles.item}>Gross Sale</h6>
                              <h6 className={styles.item}>
                                {
                                  endOfDayDetails?.completed_total_data?.[0]
                                    ?.counts
                                }
                              </h6>
                              <h6 className={styles.item}>
                                {formatCurrency({
                                  value:
                                    `${endOfDayDetails?.completed_total_data?.[0]?.amount}`?.replace(
                                      /[^\d.-]/g,
                                      "",
                                    ),
                                  currencyCode: currency_code,
                                })}
                              </h6>
                            </div>
                            <div className={styles.rowItem}>
                              <h6 className={styles.item}>Returns</h6>
                              <h6 className={styles.item}></h6>
                              <h6 className={styles.item}>
                                {formatCurrency({
                                  value:
                                    `${endOfDayDetails?.returned_amount_summary?.[0]?.returned_amount}`?.replace(
                                      /[^\d.-]/g,
                                      "",
                                    ),
                                  currencyCode: currency_code,
                                })}
                              </h6>
                            </div>
                            <div className={styles.rowItem}>
                              <h6 className={styles.item}>Net Sales</h6>
                              <h6 className={styles.item}></h6>
                              <h6 className={styles.item}>
                                {formatCurrency({
                                  value:
                                    `${endOfDayDetails?.net_sales}`?.replace(
                                      /[^\d.-]/g,
                                      "",
                                    ),
                                  currencyCode: currency_code,
                                })}
                              </h6>
                            </div>
                          </>
                        ) : (
                          <h6 className="text-center mt-2">
                            No data available
                          </h6>
                        )}
                      </div>
                    </div>
                    {/* failed */}
                    <div className={styles.orderBody__table}>
                      <div className={styles.orderBody__table__header}>
                        <h5>
                          Order Status{" "}
                          <span className="ml-3 failed--text small-text-size">
                            Cancelled
                          </span>
                        </h5>
                      </div>
                      <div className={styles.rowCover}>
                        {endOfDayDetails?.canceled_order_data?.length > 0 ? (
                          <>
                            <div className={styles.rowItem}>
                              <p className={styles.item}>SALES</p>
                              <p className={styles.item}>COUNT</p>
                              <p className={styles.item}>AMOUNT</p>
                            </div>

                            {endOfDayDetails?.canceled_order_data?.map(
                              (item, index) => (
                                <div className={styles.rowItem} key={index}>
                                  <h6 className={styles.item}>{item?.sales}</h6>
                                  <h6 className={styles.item}>
                                    {item?.counts}
                                  </h6>
                                  <h6 className={styles.item}>
                                    {formatCurrency({
                                      value: item?.amount?.replace(
                                        /[^\d.-]/g,
                                        "",
                                      ),
                                      currencyCode: currency_code,
                                    })}
                                  </h6>
                                </div>
                              ),
                            )}
                          </>
                        ) : (
                          <h6 className="text-center mt-2">
                            No data available
                          </h6>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </motion.div>

              <div
                className={`${globalStyles.stickyBottomCover} mt-auto d-flex`}
              >
                <primaryComponents.Button
                  classNames="btn btn--primary cover"
                  onClick={() =>
                    downloadEndOfDay({
                      delivery_method: "download",
                      type: "product_summary",
                      download_format: "pdf",
                    })
                  }
                  loadingText="Proccessing..."
                  isLoading={productSummaryLoadingRef.current}
                >
                  <PrintIcon />
                  <span className="ml-2">Print Product Summary</span>
                </primaryComponents.Button>
                <primaryComponents.Button
                  classNames="btn btn--green cover"
                  onClick={() =>
                    downloadEndOfDay({
                      delivery_method: "download",
                      type: "sales_summary",
                      download_format: "pdf",
                    })
                  }
                  loadingText="Proccessing..."
                  isLoading={salesSummaryLoadingRef.current}
                >
                  <PrintIcon />
                  <span className="ml-2">Print Sales Summary</span>
                </primaryComponents.Button>
                <secondaryComponents.NavigateWithPermission
                  permissionParentKey={"Inventory Management"}
                  permissionChildKey={"can_filter_for_all_users"}
                >
                  <primaryComponents.Button
                    classNames="btn btn--outline cover"
                    onClick={() => setDownloadModal(true)}
                    isLoading={salesSummaryLoadingRef.current}
                  >
                    End of Day (Legacy)
                  </primaryComponents.Button>
                </secondaryComponents.NavigateWithPermission>
              </div>
            </>
          )}
        </>
      )}

      <Modal
        isActive={downloadModal}
        width={600}
        closeModal={() => setDownloadModal(false)}
      >
        <DownloadModal
          closeModal={() => setDownloadModal(false)}
          setIsDownloadReport={setIsDownloadReport}
          downloadEndOfDay={downloadEndOfDay}
        />
      </Modal>
    </>
  );
};
export default EndOfDayDetails;
